const IS_SSR: boolean = typeof window === 'undefined';
const IS_IFRAME: boolean = IS_SSR
  ? false
  : (() => {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    })();

/**
 * Environment check flags for extended behaviour based on current mode/place.
 */
export const environmentConfig = {
  // todo: Use shared isSsr util.
  IS_SSR: IS_SSR,
  IS_IFRAME: IS_IFRAME,
  IFRAME_ALLOWED_ORIGINS: [
    'https://venues.vimeo.com',
    'https://vimeo.com',
    'https://master.ci.vimeows.com',
    'https://vimeo.dev',
    // todo: Generic work domains?
  ],
  IS_DEV: IS_SSR
    ? false
    : location.host.endsWith('vimeo.dev') || location.host.endsWith('.ci.vimeows.com'),
  IS_LOCAL_DEV: IS_SSR ? false : location.host.endsWith('vimeo.dev'),
  IS_PRODUCTION: IS_SSR || process.env.NODE_ENV === 'production',
  IS_CI: !IS_SSR && location.host.endsWith('.ci.vimeows.com'),
  IS_COM: IS_SSR || location.host.endsWith('vimeo.com') || location.host.endsWith('vimeo.work'),
  /**
   * Whether is in jest ENV.
   */
  IS_TEST: process.env.NODE_ENV === 'test',
  PROTOCOL: IS_SSR ? 'https' : location.protocol,
  HOST: IS_SSR ? 'vimeo.com' : location.host,
  URL_BASE: IS_SSR ? 'https://vimeo.com' : `${location.protocol}//${location.host}`,
  /**
   * ID of current build version when it is strictly required to mark current APP version.
   */
  BUILD_ID: `v1.0.14`,
};
